export const NotFound = () => {
  return (
    <div
      style={{
        padding: "10rem",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      <h4>404 - Not Found</h4>
      <h4> Route is Not Defined</h4>
    </div>
  );
};
